import { METADATA_KEY_MAPPING } from "./constants";

export const getMetadataKey = (index: string): string => {
    return METADATA_KEY_MAPPING[index] || "report_name";
};

export const isReportIdentifier = (key: string): boolean => {
    return Object.values(METADATA_KEY_MAPPING).includes(key);
};
